import React from "react";
import styles from "./additional-content.module.css";
import { useAppNavigate } from "@commons-monorepo/index";

const AdditionalContent = ({ img }: {img: string;}) => {
  const navigate = useAppNavigate();

  const onClose = () => {
    navigate(-1);
  };
  return (
    <div className={styles.additionalContentContainer} onClick={onClose}>
      <div className={styles.close} onClick={onClose}>
        <figure className={"icon-close"} />
      </div>
      <img
        src={img}
        onClick={(e) => {
          e.stopPropagation();
        }} />

    </div>);

};

export default AdditionalContent;